import React from 'react'
import { Badge } from 'primereact/badge';


const BadgeNotificationBar = ({eventCount}) => {

    

  return (
      <div> 
          <i className="pi pi-calendar p-overlay-badge" style={{ fontSize: '2rem' }}>
              <Badge value={eventCount }  severity="danger"></Badge>
            </i>
    </div>
  )
}

export default BadgeNotificationBar